#add-product-wrapper {
  height: 100%;

  display: flex;
  flex-direction: column;

  padding: calc(var(--spacer) * 3) 0 calc(var(--spacer) * 3) calc(var(--spacer) * 3);

  #add-product-inner-container {
    display: flex;
    flex-direction: column;
    height: 100%;
    padding-right: calc(var(--spacer) * 4);
    overflow-y: auto;

    .company-name {
      margin-top: calc(var(--spacer) * 3);
    }

    #add-product-title {
      margin-top: calc(var(--spacer) * 6);
    }

    #add-product-info-text {
      color: var(--main-titles-inputs-600);
    }
    gz-license-pre-paid-subform {
      height: auto;
      margin-bottom: calc(var(--spacer) * 2);
    }

    #add-product-form-title {
      margin-top: calc(var(--spacer) * 4);
      text-transform: uppercase;
      color: var(--chart-300-icon-buttons);
    }
  }
}

.bottom-buttons {
  width: 100%;

  margin-top: calc(var(--spacer) * 2);

  display: flex;
  align-items: center;

  gz-button {
    margin-right: calc(var(--spacer) * 2);
  }
}
